(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("webinarHistoryLearner", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learnerAccess/learningItemType/history/webinarHistoryLearnerView.html",
            controller: ["assignmentLearnerAccessWebinarResource", "messageService", "frameworkService", "$state", "$uibModal", WebinarHistoryLearnerCtrl],
            controllerAs: "vm"
        };
        function WebinarHistoryLearnerCtrl(assignmentLearnerAccessWebinarResource, messageService, frameworkService, $state, $uibModal) {
            var vm = this;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.code = $state.params.code;
            assignmentLearnerAccessWebinarResource.getWebinarHistoryViewModel({ number: vm.number, version: vm.version, code: vm.code }, function (result) {
                vm.model = result;
                vm.loaded = true;
            }, function (error) {
                messageService.error(error);
            });
            vm.viewDetails = function (webinar) {
                $uibModal.open({
                    templateUrl: "app/account/learnerAccess/learningItemType/webinarLearnerAccessViewWebinarDetailsView.html",
                    controller: ["webinar", function (webinar) {
                            var vm = this;
                            vm.webinar = webinar;
                            vm.enrollmentView = false;
                            vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
                        }],
                    controllerAs: "vm",
                    resolve: {
                        webinar: webinar
                    }
                }).result.catch(angular.noop);
            };
        }
    });
}());
